import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, TextContainer, DataTable, Badge, TextStyle } from '@shopify/polaris';
import { ta } from 'utils';

import PolarisRecordsTable from '@components/shared/ui/PolarisRecordsTable';

const propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,

  items: PropTypes.array.isRequired, // Array of objects
  columnsData: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,

}
const defaultProps = {}

const InformativeModal = (props) => {
  const currentDate = new Date();

  const errorsFound = props.errors.length > 0;

  console.log("InformativeModal", props);

  return (
    <div>
      <Modal
        open={props.open}
        large
        onClose={props.onClose}
        title={`${props.title} - ${I18n.l("time.formats.unimart_date", currentDate.toISOString())}`}
      >
        <Modal.Section>
          <TextContainer>
            { (props.items.length <= 0 && !errorsFound) && "No se encontraron resultados" }

            <PolarisRecordsTable 
              items={props.items}
              columnsData={props.columnsData}
            />

            {/* Errors if any */}
            { errorsFound && props.errors.map((error, index) => (
              <p>
                <TextStyle variation="negative" key={index}>
                  {error}
                </TextStyle>
              </p>
            )) }  
            
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  )
}

InformativeModal.propTypes = propTypes;
InformativeModal.defaultProps = defaultProps;
export default InformativeModal;
